import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import 'react-contexify/dist/ReactContexify.css';

function useNavigate() {
  const history = useHistory();

  const [ctrlKeyPressed, setCtrlKeyPressed] = useState(false);

  const handleKeyDown = e => {
    if (e.ctrlKey || e.metaKey) {
      setCtrlKeyPressed(true);
    }
  };

  const handleKeyUp = e => {
    if (!e.ctrlKey || !e.metaKey) {
      setCtrlKeyPressed(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', handleKeyUp);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', handleKeyUp);
    };
  }, []);

  const navigate = (path, target, state = null) => {
    if (target || ctrlKeyPressed) {
      window.open(path, '_blank');
    } else {
      history.push(path, state);
    }
  };

  return navigate;
}

export default useNavigate;
